import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataService } from '../data.service';
import { FormControl, NgForm, FormGroupDirective, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import { Trasllat } from '../lib/model/trasllat';
import { Localitat } from '../lib/model/localitat';
import { Pais } from '../lib/model/pais';
import { Utilitats } from '../lib/utilitats';
import { ErrorStateMatcher, MatSnackBar, MatStepper } from '@angular/material';
import { BLTrasllat } from '../lib/bl/bltrasllat';

@Component({
  selector: 'app-dades-contacte',
  templateUrl: './dades-contacte.component.html',
  styleUrls: ['./dades-contacte.component.css'],
  providers: [BLTrasllat]
})
export class DadesContacteComponent implements OnInit {

  @ViewChild('formulari') formulari: NgForm;
  @Input() stepper: MatStepper;

  emailInput = new FormControl('', [Validators.email, Validators.required]);
  trasllat: Trasllat;
  stepPerformed = false;

  paisCtrl: FormControl;
  poblacioCtrl: FormControl;

  filteredPaisos: Observable<Pais[]>;
  filteredPoblacions: Observable<Localitat[]>;

  constructor(public dataService: DataService,
              public utilitats: Utilitats,
              public blTrasllat: BLTrasllat,
              public snackBar: MatSnackBar) {

        this.trasllat = this.dataService.trasllat;

        this.paisCtrl = new FormControl();
        this.filteredPaisos = this.paisCtrl.valueChanges
            .startWith(null)
            .map(x => x ? this.dataService.filtraPaisos(x) : this.dataService.paisos);

        this.poblacioCtrl = new FormControl();
        this.filteredPoblacions = this.poblacioCtrl.valueChanges
            .startWith(null)
            .map(x => {
              if (x != null && x.length > 1) {
                return this.dataService.filtraPoblacions(x);
              } else {
                return this.dataService.poblacions.slice(0, 250);
              }
            });
  }

  async ngOnInit() {

  }

  paisChange(newValue) {
    if (newValue != null && newValue.value) {
      if ((this.trasllat.alumne.pais === null) ||
          (this.trasllat.alumne.pais.value !== newValue.value)) {
        this.trasllat.alumne.pais = newValue;
      }
    } else {
      this.trasllat.alumne.pais = null;
    }
  }

  poblacioChange(newValue) {
    if (newValue != null && newValue.value) {
      if ((this.trasllat.alumne.poblacio === null) ||
          (this.trasllat.alumne.poblacio.value !== newValue.value)) {
        this.trasllat.alumne.poblacio = newValue;
      }
    } else {
      this.trasllat.alumne.poblacio = null;
    }
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
      // TODO: Tenim una barreja de dos estils, template driven i reactive driven, per això cal validar algunes coses a banda
      if (this.emailInput.invalid && this.emailInput.value !== '') {
        return false;
      }
      if (this.utilitats.isNullOrEmpty(this.trasllat.alumne.pais)) {
        return false;
      }
      if (this.trasllat.alumne.paisEspanya()) {
        if (this.utilitats.isNullOrEmpty(this.trasllat.alumne.poblacio)) {
          return false;
        }
      } else if (this.utilitats.isNullOrEmpty(this.trasllat.alumne.poblacioText)) {
        return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }

  public async continua() {
    try {
      this.stepper.next();
      if (!this.stepPerformed) {
        this.dataService.maxStep++;
        this.stepPerformed = true;
      }
      if (!this.trasllat.isnew) {
        this.trasllat = await this.blTrasllat.save(this.trasllat);
        this.dataService.trasllat = this.trasllat;
      }
    } catch (ex) {
        console.log(ex.Message);
        this.snackBar.open(ex.Message, null, {
            duration: 10000,
          });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/dades-contacte/dades-contacte.component.ts